import React, { useState, useEffect } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
// import 'react-bootstrap-typeahead/css/Typeahead-bs4.css';

const PageTitle = (props) => {
  const [state, setState] = useState({
    data: null,
  });

  useEffect(() => {
    const data = [];
    if (props.data)
      props.data.map((item) => data.push({ id: item.id, label: item.name }));

    setState({ data: data });

    return () => {
      data.length = 0;
      setState({ data: data });
    };
  }, [props]);

  return (
    <div
      className="page-header page-header-bordered"
      style={{ padding: "30px 30px 30px", backgroundColor: "transparent" }}
    >
      <h1 className="page-title">{props.title}</h1>
      {props.search ? (
        <div className="page-header-actions">
          <div className="input-search input-search-dark">
            <i className="input-search-icon md-search" aria-hidden="true"></i>
            {state.data && (
              <Typeahead
                id={props.searchId}
                onChange={(selected) => props.searchHandler(selected)}
                options={state.data}
                clearButton
                maxResults={10}
                paginate
                placeholder={props.searchId}
                inputProps={{
                  type: "text",
                  style: {
                    padding: "1.072rem 5.072rem 1.072rem 3.109rem",
                    fontFamily: "revert",
                  },
                }}
              />
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default PageTitle;
